import { processEnv } from 'components/configuration/environmentVariables'
import { productOptions } from './ProductListingDialog.types'

export const areBadgelessCardsEnabled =
    processEnv.REACT_APP_EnableBadgelessCards === '1'

export const defaultListingOrder = `type${
    areBadgelessCardsEnabled ? ' desc' : ''
},firmName,productType,productName,lastUpdated desc`

export const PER_PAGE = 50
export const OPTIMISTIC_CARDS = 5

export const defaultProduct = {
    [productOptions.ADDED_TO_PROJECT]: false,
    [productOptions.FLAGGED_FOR_REVIEW]: false,
}

export const sustainabilityResourcesOptions = ['Sustainable Minds']
export const bimResourcesOptions = ['BIMsmith']
export const defaultFilter: string[] = !areBadgelessCardsEnabled
    ? ['Premium MasterSpec', 'Premium']
    : ['Product Listing']
